import { Quake, Origin, Magnitude, CreationInfo, EventDescription, EventParameters, ZERO_MAGNITUDE, } from "./quakeml.mjs";
import { JSON_MIME, doFetchWithTimeout, UTC_OPTIONS, defaultFetchInitObj, stringify } from "./util.mjs";
import { DateTime } from "luxon";
const timeoutSec = 10;
export const hourSummarySignificantUrl = "https://earthquake.usgs.gov/earthquakes/feed/v1.0/summary/significant_hour.geojson";
export const hourSummaryM4_5Url = "https://earthquake.usgs.gov/earthquakes/feed/v1.0/summary/4.5_hour.geojson";
export const hourSummaryM2_5Url = "https://earthquake.usgs.gov/earthquakes/feed/v1.0/summary/2.5_hour.geojson";
export const hourSummaryM1_0Url = "https://earthquake.usgs.gov/earthquakes/feed/v1.0/summary/1.0_hour.geojson";
export const hourSummaryAllUrl = "https://earthquake.usgs.gov/earthquakes/feed/v1.0/summary/all_hour.geojson";
export const daySummarySignificantUrl = "https://earthquake.usgs.gov/earthquakes/feed/v1.0/summary/significant_day.geojson";
export const daySummaryM4_5Url = "https://earthquake.usgs.gov/earthquakes/feed/v1.0/summary/4.5_day.geojson";
export const daySummaryM2_5Url = "https://earthquake.usgs.gov/earthquakes/feed/v1.0/summary/2.5_day.geojson";
export const daySummaryM1_0Url = "https://earthquake.usgs.gov/earthquakes/feed/v1.0/summary/1.0_day.geojson";
export const daySummaryAllUrl = "https://earthquake.usgs.gov/earthquakes/feed/v1.0/summary/all_day.geojson";
export const weekSummarySignificantUrl = "https://earthquake.usgs.gov/earthquakes/feed/v1.0/summary/significant_week.geojson";
export const weekSummaryM4_5Url = "https://earthquake.usgs.gov/earthquakes/feed/v1.0/summary/4.5_week.geojson";
export const weekSummaryM2_5Url = "https://earthquake.usgs.gov/earthquakes/feed/v1.0/summary/2.5_week.geojson";
export const weekSummaryM1_0Url = "https://earthquake.usgs.gov/earthquakes/feed/v1.0/summary/1.0_week.geojson";
export const weekSummaryAllUrl = "https://earthquake.usgs.gov/earthquakes/feed/v1.0/summary/all_week.geojson";
export const monthSummarySignificantUrl = "https://earthquake.usgs.gov/earthquakes/feed/v1.0/summary/significant_month.geojson";
export const monthSummaryM4_5Url = "https://earthquake.usgs.gov/earthquakes/feed/v1.0/summary/4.5_month.geojson";
export const monthSummaryM2_5Url = "https://earthquake.usgs.gov/earthquakes/feed/v1.0/summary/2.5_month.geojson";
export const monthSummaryM1_0Url = "https://earthquake.usgs.gov/earthquakes/feed/v1.0/summary/1.0_month.geojson";
export const monthSummaryAllUrl = "https://earthquake.usgs.gov/earthquakes/feed/v1.0/summary/all_month.geojson";
export const yearSignificant = "https://earthquake.usgs.gov/fdsnws/event/1/query.geojson?minsig=600";
export const USGS_TECTONIC_SUMMARY_URL = "https://earthquake.usgs.gov/ws/geoserve/layers.json?type=tectonic";
export function loadHourSummarySignificant() {
    return loadUSGSSummary(hourSummarySignificantUrl);
}
export function loadHourSummaryM4_5() {
    return loadUSGSSummary(hourSummaryM4_5Url);
}
export function loadHourSummaryM2_5() {
    return loadUSGSSummary(hourSummaryM2_5Url);
}
export function loadHourSummaryM1_0() {
    return loadUSGSSummary(hourSummaryM1_0Url);
}
export function loadHourSummaryAll() {
    return loadUSGSSummary(hourSummaryAllUrl);
}
export function loadDaySummarySignificant() {
    return loadUSGSSummary(daySummarySignificantUrl);
}
export function loadDaySummaryM4_5() {
    return loadUSGSSummary(daySummaryM4_5Url);
}
export function loadDaySummaryM2_5() {
    return loadUSGSSummary(daySummaryM2_5Url);
}
export function loadDaySummaryM1_0() {
    return loadUSGSSummary(daySummaryM1_0Url);
}
export function loadDaySummaryAll() {
    return loadUSGSSummary(daySummaryAllUrl);
}
export function loadWeekSummarySignificant() {
    return loadUSGSSummary(weekSummarySignificantUrl);
}
export function loadWeekSummaryM4_5() {
    return loadUSGSSummary(weekSummaryM4_5Url);
}
export function loadWeekSummaryM2_5() {
    return loadUSGSSummary(weekSummaryM2_5Url);
}
export function loadWeekSummaryM1_0() {
    return loadUSGSSummary(weekSummaryM1_0Url);
}
export function loadWeekSummaryAll() {
    return loadUSGSSummary(weekSummaryAllUrl);
}
export function loadMonthSummarySignificant() {
    return loadUSGSSummary(monthSummarySignificantUrl);
}
export function loadMonthSummaryM4_5() {
    return loadUSGSSummary(monthSummaryM4_5Url);
}
export function loadMonthSummaryM2_5() {
    return loadUSGSSummary(monthSummaryM2_5Url);
}
export function loadMonthSummaryM1_0() {
    return loadUSGSSummary(monthSummaryM1_0Url);
}
export function loadMonthSummaryAll() {
    return loadUSGSSummary(monthSummaryAllUrl);
}
export function loadMonthSignificant() {
    const now = DateTime.utc();
    const monthAgo = now.minus({ month: 1 });
    return loadSignificant(monthAgo, now);
}
export function loadYearSignificant() {
    const now = DateTime.utc();
    const yearAgo = now.minus({ years: 1 });
    return loadSignificant(yearAgo, now);
}
export function loadSignificant(start, end) {
    return loadUSGSSummary(`${yearSignificant}&starttime=${start.toISO()}&endtime=${end.toISO()}`);
}
export function loadUSGSSummary(url) {
    return loadUSGSGeoJsonSummary(url).then((eventParameters) => {
        return eventParameters.eventList;
    });
}
export function loadUSGSGeoJsonSummary(url) {
    return loadRawUSGSGeoJsonSummary(url).then((geojson) => {
        return parseGeoJSON(geojson);
    });
}
export function loadRawUSGSGeoJsonSummary(url) {
    const fetchInit = defaultFetchInitObj(JSON_MIME);
    return doFetchWithTimeout(url, fetchInit, timeoutSec * 1000)
        .then((response) => {
        if (response.status !== 200) {
            // no data
            return [];
        }
        else {
            return response.json();
        }
    })
        .then((jsonValue) => {
        if (isValidUSGSGeoJsonSummary(jsonValue)) {
            return jsonValue;
        }
        else {
            throw new TypeError(`Oops, we did not get roottype JSON!`);
        }
    });
}
/*

[
{
  "type":"Feature",
  "properties":{
    "mag":4.7,
    "place":"central Mid-Atlantic Ridge",
    "time":1676729263180,
    "updated":1676730921040,
    "tz":null,
    "url":"https://earthquake.usgs.gov/earthquakes/eventpage/us6000jpxe",
    "detail":"https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us6000jpxe.geojson",
    "felt":null,
    "cdi":null,
    "mmi":null,
    "alert":null,
    "status":"reviewed",
    "tsunami":0,
    "sig":340,
    "net":"us",
    "code":"6000jpxe",
    "ids":",us6000jpxe,",
    "sources":",us,",
    "types":",origin,phase-data,",
    "nst":27,
    "dmin":14.339,
    "rms":0.71,
    "gap":90,
    "magType":"mb",
    "type":"earthquake",
    "title":"M 4.7 - central Mid-Atlantic Ridge"
  },
  "geometry":{
    "type":"Point",
    "coordinates":[-36.0365,7.3653,10]
  },
  "id":"us6000jpxe"}
],
    "bbox":[-149.9803,7.3653,3.98,-36.0365,61.4684,32.6]
  }
 */
/**
 * Parses geojson from USGS feeds. Not all fields are parsed, just
 * basic origin and magnitude along with the id.
 * See https://earthquake.usgs.gov/earthquakes/feed/v1.0/geojson.php
 * @param  geojson  text from USGS feed
 * @returns EventParameters, which holds an array of Quake objects
 */
export function parseGeoJSON(geojson) {
    const quakeList = [];
    const description = geojson.metadata.title;
    for (const f of geojson.features) {
        const quake = parseFeatureAsQuake(f);
        quakeList.push(quake);
    }
    const out = new EventParameters();
    out.creationInfo = new CreationInfo();
    out.creationInfo.agencyURI = geojson.metadata.url;
    out.creationInfo.creationTime = DateTime.fromMillis(geojson.metadata.generated, UTC_OPTIONS);
    out.eventList = quakeList;
    out.description = description;
    return out;
}
/**
 * Parses a single GeoJson feature into a Quake.
 * @param  feature  from USGS style geojson
 * @returns Quake with origin and magnitude
 */
export function parseFeatureAsQuake(feature) {
    const quake = new Quake();
    quake.publicId = `quakeml:earthquake.usgs.gov/fdsnws/event/1/query?eventid=${feature.id}`;
    const p = feature.properties;
    if (p == null) {
        throw new Error("Geojson missing properties");
    }
    quake.eventId = stringify(feature.id);
    quake.descriptionList.push(new EventDescription(p.title));
    const origin = new Origin(DateTime.fromMillis(p.time, UTC_OPTIONS), feature.geometry.coordinates[1], feature.geometry.coordinates[0]);
    origin.depth = feature.geometry.coordinates[2] * 1000;
    quake.originList.push(origin);
    const mag = (p?.mag != null) ? new Magnitude(p.mag) : ZERO_MAGNITUDE;
    mag.type = p.magType ? p.magType : ZERO_MAGNITUDE.type;
    quake.preferredOrigin = origin;
    quake.preferredMagnitude = mag;
    quake.magnitudeList.push(mag);
    return quake;
}
export function isValidUSGSGeoJsonSummary(jsonValue) {
    if (!jsonValue || typeof jsonValue !== "object") {
        throw new TypeError("json is not object");
    }
    const jsonObj = jsonValue;
    if (!(typeof jsonObj.type === "string" && jsonObj.type === "FeatureCollection")) {
        throw new TypeError("geojson is not valid for USGS GeoJson, type should be FeatureCollection");
    }
    if (!(typeof jsonObj.metadata === "object")) {
        throw new TypeError("geojson is not valid for USGS GeoJson, missing metadata");
    }
    if (!Array.isArray(jsonObj.features)) {
        throw new TypeError("geojson is not valid for USGS GeoJson, features should be array");
    }
    else {
        if (!jsonObj.features.every(isValidUSGSGeoJsonQuake)) {
            throw new TypeError("geojson is not valid for USGS GeoJson, feature should be USGSGeoJsonFeature");
        }
    }
    return true;
}
export function isValidUSGSGeoJsonQuake(jsonValue) {
    if (!jsonValue || typeof jsonValue !== "object") {
        throw new TypeError("json is not object");
    }
    const jsonObj = jsonValue;
    if (!(typeof jsonObj.type === "string" && jsonObj.type === "Feature")) {
        throw new TypeError("geojson is not valid for USGS GeoJson, type should be Feature");
    }
    if (!(typeof jsonObj.properties === "object")) {
        throw new TypeError("geojson is not valid for USGS GeoJson, missing properties");
    }
    if (!(typeof jsonObj.id === "string")) {
        throw new TypeError("geojson is not valid for USGS GeoJson, id should be string");
    }
    return true;
}
export function loadUSGSTectonicLayer(url) {
    if (!url) {
        url = USGS_TECTONIC_SUMMARY_URL;
    }
    const fetchInit = defaultFetchInitObj(JSON_MIME);
    return doFetchWithTimeout(url, fetchInit, timeoutSec * 1000)
        .then((response) => {
        if (response.status !== 200) {
            // no data
            return [];
        }
        else {
            return response.json();
        }
    })
        .then((jsonValue) => {
        if (isValidUSGSTectonicGeoJsonSummary(jsonValue)) {
            return jsonValue;
        }
        else {
            throw new TypeError(`Oops, we did not get roottype JSON!`);
        }
    });
}
export function isValidUSGSTectonicGeoJsonSummary(jsonValue) {
    if (!jsonValue || typeof jsonValue !== "object") {
        throw new TypeError("json is not object");
    }
    const jsonObj = jsonValue;
    if (!jsonObj.tectonic || typeof jsonObj.tectonic !== "object") {
        throw new TypeError("json.tectonic is not object");
    }
    const tectonic = jsonObj.tectonic;
    if (!(typeof tectonic.type === "string"
        && tectonic.type === "FeatureCollection")) {
        throw new TypeError("geojson is not valid for USGS GeoJson, tectonic should be FeatureCollection");
    }
    if (!(typeof jsonObj.metadata === "object")) {
        throw new TypeError("geojson is not valid for USGS GeoJson, missing metadata");
    }
    if (!Array.isArray(tectonic.features)) {
        throw new TypeError("geojson is not valid for USGS GeoJson, features should be array");
    }
    else {
        // should check for subobjects have name, summary, type
        if (!tectonic.features.every(isValidUSGSTectonic)) {
            throw new TypeError("geojson is not valid for USGS GeoJson, feature should be USGSTectonicGeoJsonFeature");
        }
    }
    return true;
}
export function isValidUSGSTectonic(jsonValue) {
    if (!jsonValue || typeof jsonValue !== "object") {
        throw new TypeError("json is not object");
    }
    const jsonObj = jsonValue;
    if (!(typeof jsonObj.type === "string" && jsonObj.type === "Feature")) {
        throw new TypeError("geojson is not valid for USGS GeoJson, type should be Feature");
    }
    if (!(typeof jsonObj.properties === "object")) {
        throw new TypeError("geojson is not valid for USGS GeoJson, missing properties");
    }
    if (!(typeof jsonObj.id === "string" || typeof jsonObj.id === "number")) {
        throw new TypeError("geojson is not valid for USGS GeoJson, id should be string");
    }
    return true;
}
//# sourceMappingURL=usgsgeojson.mjs.map